import type { Pronunciation } from 'js/src/client';

export type PronunciationIDType = Pronunciation['id'];

export type UpdatedPronunciation = {
    id: PronunciationIDType;
    pronunciation: Pronunciation['pronunciation'];
};

// the same regex in the backend to clean words is in pronunciation.py
export const STRIPPED_PUNCTUATIONS_REGEX = /[!"#$&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
export const MAX_PRONUNCIATION_WORDS = 3;

export const PronunciationLibraryColumnIds = {
    WordSlashPhrase: 'Word-Phrase',
    Pronunciation: 'Pronunciation',
    Language: 'Language',
    Action: 'Action',
};
